import { useQuery } from "@tanstack/react-query";
import { getAdahiData } from "../api";
import { reactQueryCacheAndRefetchOptions } from "@";
import { projectsKeys } from "./keys";
import type { AdahiProduct, AdahiRitual } from "../../types";

interface AdahiDataResult {
  adahiProducts: AdahiProduct[];
  adahiRitual: AdahiRitual[];
}

// Query hook for fetching Adahi data
export const useAdahiDataQuery = () => {
  return useQuery<AdahiDataResult>({
    queryKey: projectsKeys.adahiData(),
    queryFn: async () => {
      const [adahiProductsRes, adahiRitualRes] = await getAdahiData();
      return {
        adahiProducts: adahiProductsRes.data || [],
        adahiRitual: adahiRitualRes.data || [],
      };
    },
    ...reactQueryCacheAndRefetchOptions,
  });
};
